module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_vm._v("\n  " + _vm._s(_vm.counter) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35a4061e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextCounter.vue
// module id = 1066
// module chunks = 1